// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"df17bdd6","185":"bbea04c0","218":"450bcbdb","272":"cfcbb41f","282":"f9dde040","293":"fdbcc4c7","411":"7bfccfc1","527":"f98994e4","598":"7585645a","635":"51698f0a","779":"06c4e197","873":"e914331b"}[chunkId] + ".chunk.js";
};